import { render, staticRenderFns } from "./Portefeuille.vue?vue&type=template&id=624e0b8c&scoped=true&"
import script from "./Portefeuille.vue?vue&type=script&lang=js&"
export * from "./Portefeuille.vue?vue&type=script&lang=js&"
import style0 from "./Portefeuille.vue?vue&type=style&index=0&id=624e0b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624e0b8c",
  null
  
)

export default component.exports